import React from 'react';
import styled from 'styled-components';
import { Title, Text } from 'components/v3/ui';
import img from 'common/images/404.gif';

const Wrapper = styled.div`
  background: #fff;
  height: calc(100vh - 56px);
  text-align: center;

  img {
    width: auto;
  }
} 
`;

const Content = styled.div`
  margin-top: -150px;
`;

const NotFound = () => {
  return (
    <Wrapper>
      <img src={img} alt="404_img" />
      <Content>
        <Title>On dirait que vous êtes perdu</Title>
        <Text alignCenter>La page que vous recherchez n'existe pas!</Text>
      </Content>
    </Wrapper>
  );
};

export default NotFound;
